export const QMS_CATEGORY_ERROR_MESSAGES = {
  REQUIRED: 'To pole jest wymagane.',
  NAME_TOO_LONG: 'Category name cannot exceed 50 characters.',
  DESCRIPTION_TOO_LONG: 'Description cannot exceed 500 characters.',
  NAME_ALREADY_EXISTS: 'This category name already exists',
  VALIDATION_ERROR: 'Invalid data. Please check your input and try again.',
  UNAUTHORIZED: 'Brak uprawnień do wykonania tej operacji.',
  NETWORK_ERROR: 'Błąd sieci. Sprawdź połączenie i spróbuj ponownie.',
  INTERNAL_SERVER_ERROR: 'Błąd serwera. Spróbuj ponownie później.',
  DEFAULT_ERROR: 'Wystąpił błąd. Spróbuj ponownie.',
  UNEXPECTED_ERROR: 'Nieoczekiwany błąd. Spróbuj ponownie.',
  TAG_INVALID_FORMAT:
    'Tag can only contain letters, numbers, hyphens, and underscores.',
  TAG_TOO_LONG: 'Tag cannot exceed 30 characters.',
  TAG_DUPLICATE: 'This tag already exists.',
  TAG_EMPTY: 'Tag value cannot be empty.',
  TAG_MAX_COUNT_REACHED: 'Maximum of 10 tags allowed.',
  TAG_NOT_ADDED:
    'Wprowadzony tag nie został dodany. Kliknij „Dodaj", aby go potwierdzić.',
  FETCH_CATEGORY_ERROR: 'Wystąpił błąd podczas ładowania danych kategorii.',
  UPDATE_ERROR: 'Wystąpił błąd podczas aktualizacji kategorii.',
  NO_PERMISSION_TOOLTIP: 'Nie masz uprawnień do wykonania tej czynności',
} as const;
